import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "@/lib/interactionLog";

/** Records every screen change, with where it came from. Renders nothing. */
export default function RouteLogger() {
  const location = useLocation();
  const previous = useRef(null);

  useEffect(() => {
    const to = `${location.pathname}${location.search}${location.hash}`;
    logEvent("navigate", { from: previous.current, to });
    previous.current = to;
  }, [location.pathname, location.search, location.hash]);

  return null;
}
